import { Component, EventEmitter, OnDestroy, Output, AfterViewInit, ElementRef, Input } from '@angular/core';

declare global {
  interface Window {
    turnstile: any;
  }
}

@Component({
  selector: 'app-turnstile',
  standalone: true,
  template: `<div #widgetContainer></div>`
})
export class TurnstileComponent implements AfterViewInit, OnDestroy {
  @Input() siteKey!: string;
  @Output() tokenGenerated = new EventEmitter<string>();
  @Output() tokenExpired = new EventEmitter<void>();

  private widgetId: string | null = null;

  constructor(private elRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.renderWidget();
  }

  private renderWidget(): void {
    // Aspetta che lo script Turnstile sia caricato
    const interval = setInterval(() => {
      if (window.turnstile) {
        clearInterval(interval);
        this.widgetId = window.turnstile.render(
          this.elRef.nativeElement.querySelector('div'),
          {
            sitekey: this.siteKey,
            appearance: 'interaction-only',
            callback: (token: string) => this.tokenGenerated.emit(token),
            'expired-callback': () => this.tokenExpired.emit(),
            'error-callback': () => this.tokenExpired.emit()
          }
        );
      }
    }, 100);
  }

  reset(): void {
    if (this.widgetId && window.turnstile) {
      window.turnstile.reset(this.widgetId);
    }
  }

  ngOnDestroy(): void {
    if (this.widgetId && window.turnstile) {
      window.turnstile.remove(this.widgetId);
    }
  }
}